import { ProjectStatus } from '@/schemas'

export const statusOptions = [
  {
    label: '未开始',
    value: ProjectStatus.未开始,
  },
  {
    label: '计划中',
    value: ProjectStatus.计划中,
  },
  {
    label: '进行中',
    value: ProjectStatus.进行中,
  },
  {
    label: '暂停',
    value: ProjectStatus.暂停,
  },
  // {
  //   label: '结项中',
  //   value: ProjectStatus.结项中,
  // },
  {
    label: '已结项',
    value: ProjectStatus.已结项,
  },
]
